import React from 'react';
import { envCheck } from '../../helpers/endpoints';
import Headline from '../ui/headline';
import Modal from '../ui/modal';

export default ({
    modalGenerateReporting,
    toggleGenerateModalReporting,
    jwtToken
}) => (
    <Modal
        title="Generate Report"
        classes="btn btn--secondary align-left"
        modalClassName="modal--reporting"
        closeButtonCopy="Cancel"
        toggleAction={modalGenerateReporting}
        toggleModal={toggleGenerateModalReporting}
    >
        <Headline title="Select Report To Generate" tagValue="4" />

        <a
            className="reporting__generate-link"
            href={`https://${envCheck}ems.marines.com/reporting/same?t=${jwtToken}`}
            target="_blank"
        >
            <svg className="icon icon-download">
                <use xlinkHref="#icon-download" />
            </svg>
            Marine Corps Recruiting Command Semi-Annual Marketing Engagement
            Contract Report
        </a>
        <a
            className="reporting__generate-link"
            href={`https://${envCheck}ems.marines.com/reporting/same10k?t=${jwtToken}`}
            target="_blank"
        >
            <svg className="icon icon-download">
                <use xlinkHref="#icon-download" />
            </svg>
            MCRC Marketing Engagement Contracts Exceeding $10,000
        </a>
    </Modal>
);



// WEBPACK FOOTER //
// ./src/components/reporting/generate-modal.js